import createAction from 'redux-actions/es/createAction';
import {reset} from 'redux-form';
import {FeatchsignUp as api }  from '../api/index';
import { toastr } from 'react-redux-toastr';
import {redirectUrlClear} from '../../execuation-dashboard/actions/index';

export const signUp = createAction('SIGNUP_START');
export const signUpFail = createAction('SIGNUP_FAIL');
export const signUpSuccess = createAction('SIGNUP_SUCCESS');

const  signUpSuccessfully = (res)=>{
    return res.data.includes('Successfully')? toastr.success('Registration', res.data):toastr.error('Registration', res.data);
    // return this.props.action({type:signUpSuccess , paylod:res});
}

const signUpFailed =(res) =>{
     toastr.error('Registration', res);
}

export const  fetchSignUp = (values,reset)=> {
    return  async ()=> {
        return await api(values)
        .then(res => {
            signUpSuccessfully( res);
            reset('signUpForm');
            
        })
        .catch(err => {
            signUpFailed(err.message);
        });
    }
  
}

export const clearurl = () => {
    return (dispatch) => {
      dispatch(redirectUrlClear({}));
    };
  };
  
